import * as React from "react";
import {
  Alert,
  AlertTitle,
  Button,
  Typography,
  Modal,
  ButtonGroup,
  Grid,
  Paper,
  Box,
} from "@mui/material";
import Calculate from "@mui/icons-material/Calculate";
import firebase from "firebase/compat/app";
import "firebase/compat/analytics";
import AnimatedNumbers from "react-animated-numbers";


export default function AccordionEarnDetails(props) {
  //console.log("im props", props)
  return (
    <div>
      <Grid container spacing={2}>
        <React.Fragment>
          <Grid item xs={12} md={8}>
            <Alert
              style={{ textAlign: "left" }}
              variant="standard"
              severity="info"
            >
              <AlertTitle style={{ textAlign: "left" }}>
                Earn 1 point for every on-grade-level lesson you complete using
                Imagine Math
              </AlertTitle>
              <ul>
                <li>
                  Lessons Completed:{" "}
                  {props.edTechData[0].edtech_total_lessons_passed}{" "}
                </li>
                <li>
                  On Grade Level Pass Rate:{" "}
                  {props.edTechData[0].edtech_on_grade_level_pass_rate}
                </li>
                <li>Points = Lessons Completed * Pass Rate/100</li>
              </ul>
              <ButtonGroup>
                <Button
                  color="secondary"
                  style={{ justifyContent: "left" }}
                  variant="contained"
                  href="https://math.imaginelearning.com/users/sign_in"
                  target="_blank"
                  onClick={() =>
                    firebase.analytics().logEvent("page_view", {
                      page_title: "logged into Imagine Math",
                    })
                  }
                >
                  Login to Imagine Math
                </Button>
              </ButtonGroup>
            </Alert>
          </Grid>
          <Grid item xs={12} md={4}>
          <div style={{ textAlign: "center" }}>
              <Typography variant="subtitle2">
            {props.language === "english" ? "Points" : "Puntos"}
          </Typography>
          <Typography variant="h3">
            <AnimatedNumbers
              animateToNumber=
                {props.edTechData[0].edtech_points
                  ? props.edTechData[0].edtech_points
                  : 0}
                  ></AnimatedNumbers>
              </Typography>
              </div>
          </Grid>
          {/* shows when imagine math data was updated */}
          <Grid item xs={12} md={12}>
            <Box m={2} />
            <Typography variant="subtitle2" style={{ float: "right" }}>
              {props.edTechData[0].edtech_export_date
                ? `Data updated: ${props.edTechData[0].edtech_export_date.value}`
                : "No data found. Make sure you have finished some lessons in Imagine Math"}
            </Typography>
          </Grid>
        </React.Fragment>
      </Grid>
      <Box m={2} />
    </div>
  );
}
